export const setLoading = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  }
};
